import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

export const LearnerMenu: AnyLinkType[] = [
    {
        type: 'link',
        label: 'navigation.home',
        link: '/home',
    },
    {
        type: 'linkGroup',
        label: 'navigation.contents',
        links: [
            {
                type: 'link',
                label: 'navigation.assignment_learner',
                link: '/followed/tab/list',
            },
            {
                type: 'accordionLinkGroup',
                label: 'navigation.corpus_group',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.corpus_global',
                        link: '/corpus/11057',
                    },
                    {
                        type: 'link',
                        label: 'navigation.corpus_user',
                        link: '{{USER_CORPUS_LINK}}',
                    },
                ],
            },
            {
                type: 'accordionLinkGroup',
                label: 'navigation.tools',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.notepad',
                        link: '/notepad/list',
                    },
                    {
                        type: 'link',
                        label: 'navigation.mindmap',
                        link: '/mindmap/list',
                    },
                ],
            },
        ],
    },
    {
        type: 'linkGroup',
        links: [
            {
                type: 'link',
                label: 'navigation.legal_notice',
                link: '/informations-legales',
            },
            {
                type: 'link',
                label: 'navigation.who_are_we',
                link: '/page/qui-sommes-nous',
            },
            {
                type: 'link',
                label: 'navigation.site_map',
                link: '/page/site-map',
            },
        ],
    },
];
